import React, { ReactElement } from 'react'
import styled from 'styled-components'
import { Wrapper, Image, H, Button, ShareIcon } from '@farewill/ui'
import { COLOR } from '@farewill/ui/tokens'
import { screen, screenMax, screenMin } from '@farewill/ui/helpers/responsive'

import WrapperWithEdge from 'components/WrapperWithEdge'

const StyledTextureLeft = styled(Image)`
  position: absolute;
  pointer-events: none;

  left: -110%;
  bottom: -5%;

  ${screen.s`
    left:  -70%;
    top: -110px;
  `};

  ${screen.m`
    left:  -1rem;
    bottom: 5%;
  `};

  ${screenMin.l`
    left: -1rem;
    top: 10%;
    bottom: auto;
  `};
`

const StyledTextureRight = styled(Image)`
  position: absolute;
  pointer-events: none;
  right: -25%;
  top: 0;

  ${screenMin.m`
    right: -15%;
  `};

  ${screenMin.l`
    top: 20%;
    right: 0;
  `}
`

const StyledOuterWrapper = styled(Wrapper)`
  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  ${screen.m`
    min-height: 40vh;
  `}

  ${screenMin.l`
    min-height: 40vh;
  `}
`

const StyledInnerWrapper = styled(Wrapper)`
  position: relative;

  ${screenMax.s`
    a {
      width: 100%;
      max-width: none;
    }
  `}
`

const Hero = ({
  roleName,
  roleUrl,
}: {
  roleName: string
  roleUrl: string
}): ReactElement => (
  <WrapperWithEdge direction="down" edgeBackgroundColor={COLOR.WHITE}>
    <StyledOuterWrapper>
      <StyledTextureLeft
        path="textures/sketchy-swoop-yellow-03_k3g7yy"
        width={200}
        widthFromL={250}
        loading="auto"
      />
      <StyledTextureRight
        path="textures/detail_new_yellow02"
        width={350}
        loading="auto"
      />

      <StyledInnerWrapper container centeredFromM>
        <H size="XL" as="h1" decorative>
          {roleName}
        </H>
        <Button.White
          wide
          href={roleUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          <ShareIcon width={24} />
          &nbsp;Apply via Dignity
        </Button.White>
      </StyledInnerWrapper>
    </StyledOuterWrapper>
  </WrapperWithEdge>
)

export default Hero
